import React from "react";
import { TextField, Card, Typography, CardContent, CardActions, Button, Paper, Stack, Divider, Tooltip, IconButton, DialogTitle, DialogContent, DialogActions, ImageList, ImageListItem, ImageListItemBar } from "@mui/material";
import { Timeline, TimelineItem, TimelineDot, TimelineConnector, TimelineSeparator, TimelineContent } from "@mui/lab";
import { timelineItemClasses } from '@mui/lab/TimelineItem';
import { DataGrid } from '@mui/x-data-grid';
import { ptBR } from "@mui/x-data-grid/locales";
import { D } from "../include";
import { WhatsApp, MoreVert, Link, LinkOff, Sync, PlayCircle, PauseCircle, ReportProblemOutlined, Check, Restore, Speed, ChatOutlined, ImageOutlined, Add, Clear } from "@mui/icons-material";
import {QRCodeSVG} from 'qrcode.react';
import dayjs from 'dayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'

const INTERVAL_MIN=1, INTERVAL_MAX=60;


export class WhatsAppManager extends React.Component {
  constructor(props) {
    super(props);
    var start = dayjs().add(1,'days');
    var end = start.subtract(1,'year');
    this.state = {
      contacts: [],
      dataTable: [],
      dataini: end.format('YYYY-MM-DD'),
      datafim: start.format('YYYY-MM-DD'),
    };
    
    this.columns = [
      { field: 'id', headerName: '', width: 30 },
      { field: 'status', headerName: 'Status', width: 60 },
      { field: 'number', headerName: 'Telefone', width: 150 },
      { field: 'name', headerName: 'Nome', width: 250 },
      { field: 'date', headerName: 'Data', width: 250 },
      { field: 'timestamp', headerName: 'Timestamp', width: 120 },
    ];
  }    
  
  
    
  componentDidMount() {
    this.setState({ loading: true }); 
 
    
    var c = [
          {"name": "Flávio Luis de Mello","number": "5521982317568","timestamp": 1777220287},
          {"name": "☠️","number": "5521964884414","timestamp": 1776960382},
          {"name": "Vt Mal","number": "5521989855630","timestamp": 1776977914},
          {"name": "Dart Vader","number": "552192317268","timestamp": 1776978000},
          {"name": "Alf","number": "552192734904","timestamp": 1776979000},
          {"name": "Cap Nemo","number": "5521912340987","timestamp": 1776979500},
          {"name": "Dino da Silva Sauro","number": "5521967548392","timestamp": 1776980000},
          {"name": "Mario","number": "5521909438745","timestamp": 1776981000},
          {"name": "Flávio Luis de Mello","number": "5521982317568","timestamp": 1777220287},
          {"name": "☠️","number": "5521964884414","timestamp": 1776960382},
          {"name": "Vt Mal","number": "5521989855630","timestamp": 1776977914},
          {"name": "Dart Vader","number": "552192317268","timestamp": 1776978000},
          {"name": "Alf","number": "552192734904","timestamp": 1776979000},
          {"name": "Cap Nemo","number": "5521912340987","timestamp": 1776979500},
          {"name": "Dino da Silva Sauro","number": "5521967548392","timestamp": 1776980000},
          {"name": "Mario","number": "5521909438745","timestamp": 1776981000},
          {"name": "Flávio Luis de Mello","number": "5521982317568","timestamp": 1777220287},
          {"name": "☠️","number": "5521964884414","timestamp": 1776960382},
          {"name": "Vt Mal","number": "5521989855630","timestamp": 1776977914},
          {"name": "Dart Vader","number": "552192317268","timestamp": 1776978000},
          {"name": "Alf","number": "552192734904","timestamp": 1776979000},
          {"name": "Cap Nemo","number": "5521912340987","timestamp": 1776979500},
          {"name": "Dino da Silva Sauro","number": "5521967548392","timestamp": 1776980000},
          {"name": "Mario","number": "5521909438745","timestamp": 1776981000},
          {"name": "Flávio Luis de Mello","number": "5521982317568","timestamp": 1777220287},
          {"name": "☠️","number": "5521964884414","timestamp": 1776960382},
          {"name": "Vt Mal","number": "5521989855630","timestamp": 1776977914},
          {"name": "Dart Vader","number": "552192317268","timestamp": 1776978000},
          {"name": "Alf","number": "552192734904","timestamp": 1776979000},
          {"name": "Cap Nemo","number": "5521912340987","timestamp": 1776979500},
          {"name": "Dino da Silva Sauro","number": "5521967548392","timestamp": 1776980000},
          {"name": "Mario","number": "5521909438745","timestamp": 1776981000},
        ];        
        c.forEach((item, index) => {
          item["id"] = index;
          item["status"] = -1;
          item["date"] = dayjs.unix(item["timestamp"]).toString();
          item["timeToNextMessage"] = 0.0;
          item["message"] = "";
        });        
        
    this.setState({ contacts: structuredClone(c), dataTable: c, loading: false });
  }
  

  
  

  

  
  

  
  


  
  
  

  
  
  filterByDate = (dataini, datafim, contacts) => {
    var aux = [];
    //Do filter
    contacts.forEach((item, index) => {
      if( (item["timestamp"] <= dayjs(datafim).unix()) && (item["timestamp"] >= dayjs(dataini).unix()) ){
        aux.push(item);
      }
    });
    return aux;
  }
  
  
  
  onChangeDate = (params) => {
    this.setState({ loading: true });
    
    var aux = this.filterByDate(params.dataini, params.datafim, this.state.dataTable);        
    this.computeBatch(aux,this.state.batch_messages,this.state.batch_interval_min,this.state.batch_interval_max,this.state.batch_images);
    
    this.setState({ loading: false, dataini: params.dataini, datafim: params.datafim, dataTable: aux });
  };  
  
  
  
  

  
  

  
  

  

  
  

  



  
  
      
  render() {
    return (
      <>
      <D className="col e aF scD" style={{ padding: "2rem" }}>
        <Stack>

           
           
           
          <D className="col e aF scD" style={{ padding: '1rem',  backgroundColor: '#f9fbfd' }}>
            <D className="row w">             
               <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Data inicial"
                  format="DD/MM/YYYY"
                  value={dayjs(this.state.dataini)}
                  slotProps={{ textField: { size: 'small', InputLabelProps: { shrink: true } } }}
                  onChange={(newValue) =>
                    this.onChangeDate({
                      dataini: newValue.format('YYYY-MM-DD'),
                      datafim: this.state.datafim,
                    })
                  }
                />
              </LocalizationProvider>
              <D size="1rem" />
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Data final"
                  format="DD/MM/YYYY"
                  value={dayjs(this.state.datafim)}
                  slotProps={{ textField: { size: 'small', InputLabelProps: { shrink: true } } }}
                  onChange={(newValue) =>
                    this.onChangeDate({
                      dataini: this.state.dataini,
                      datafim: newValue.format('YYYY-MM-DD'),
                    })
                  }
                />
              </LocalizationProvider>
              <D size="1rem" />
              <Tooltip title="Restaurar Contatos" arrow style={{padding: '0rem', margin: '0rem'}}>
                <span>
                <IconButton onClick={() => console.log("Restore")} >
                  <Restore />
                </IconButton>
                </span>
              </Tooltip> 
            </D>
          </D>
           
           
           
           
          <Paper sx={{ width: '100%', height: '800px', overflow: 'hidden' }}>
            <DataGrid
              rows={this.state.dataTable}
              columns={this.columns}
              pagination={true}
              paginationMode="client"
              loading={this.state.loading}                    
              disableSelectionOnClick
              localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
          />
          </Paper> 
           
           
           
           
           
           
           
           
           
           
           
           
        </Stack>
      </D>
    </>
      
      



      
    
      
      

      
      
      
      
    );
  }
}











